import {isString} from "./string";

export const ScriptFragment = '<script[^>]*>([\\S\\s]*?)<\/script>';

function extractScripts(text) {
    if (text === null) { return [] }
    if (!isString(text)) { return [] }
    const matchAll = new RegExp(ScriptFragment, 'img');
    const matchOne = new RegExp(ScriptFragment, 'im');
    return (text.match(matchAll) || []).map(function(scriptTag) {
        return (scriptTag.match(matchOne) || ['', ''])[1];
    });
}

export function evalScripts(text) {
    return extractScripts(text).map(s => {
        try {
            new Function(s)();
        } catch (e) { }
    });
}

export function executeScriptsInNode(node, doc = document) {
    const scripts = node.querySelectorAll('script');
    scripts.forEach(script => {
        const newScript = doc.createElement('script');
        if (script.src) {
            // For external scripts, set the src attribute
            newScript.src = script.src;
            newScript.type = script.type;
            if (script.async) newScript.async = script.async;
            if (script.defer) newScript.defer = script.defer;
        } else {
            // For inline scripts, copy the text content
            newScript.textContent = script.textContent;
        }
        // Append the new script tag to the document
        doc.body.appendChild(newScript);
    });
}